<template>
  <GModal v-if="showModal" class="custom-modal modal--discard-add-product" :noscroll="true">
    <div slot="header">
      <h2 class="modal-heading">Discard</h2>
    </div>
    <div slot="body">
      <p class="modal-text">{{ message }}</p>

      <div class="row">
        <div class="col-xs-6">
          <a href="" target="_blank" rel="noopener" class="btn btn-cancel" @click.prevent="close"> Cancel </a>
        </div>
        <div class="col-xs-6">
          <a href="" class="btn red" @click.prevent="discard"> Discard </a>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'modal-discard-add-product',
  computed: {
    showModal() {
      return this.$store.state.modal.isModalShow.discardAddProduct;
    },
    message() {
      if (this.isBeautyProfilePage) {
        return 'Apakah kamu ingin membatalkan untuk melengkapi beauty profile?';
      }
      if (this.$store.state.modal.discardAddProduct.data) {
        return 'Kamu akan meninggalkan halaman ini. data yang kamu masukkan tidak akan disimpan.';
      }
      return 'Apakah kamu ingin membatalkan untuk menambahkan produk baru?';
    },
    isDiscardAddProduct() {
      return this.$store.state.modal.discardAddProduct.data;
    },
    redirectUrl() {
      return this.$store.state.redirectUrl;
    },
    isBeautyProfilePage() {
      return this.$route.name === 'BeautyProfile';
    },
  },
  methods: {
    close() {
      if (this.isDiscardAddProduct) {
        this.$store.commit('setDataModal', {
          modalName: 'discardAddProduct',
          value: false,
        });
      }
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'discardAddProduct',
      });
    },
    discard() {
      if (this.isDiscardAddProduct) {
        this.$router.push(this.redirectUrl);
        this.$store.commit('toggleModalGlobalState', {
          modalName: 'discardAddProduct',
        });
        return;
      }
      this.$emit('discard');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal--discard-add-product ::v-deep {
  .btn {
    width: 100%;
  }

  .btn-cancel {
    border: 1px solid #231f20;
    border-radius: 4px;
    color: #231f20;
    &:hover {
      color: #231f20;
    }
  }

  .row {
    margin-right: -4px;
    margin-left: -4px;
    .col-xs-6 {
      padding: 0 4px;
    }
  }
  .modal-dialog {
    width: 305px;
    height: 162px;
    border-radius: 4px;
    box-shadow: 1px 2px 14px 0px rgba(#231f20, 0.24);
  }

  .modal-body {
    padding-top: 0;
  }

  .modal-header {
    padding: 16px 16px 20px 16px;
    .close {
      margin: 0;
      top: 13px;
      right: 16px;
    }
  }

  .modal-heading {
    font: 13px/18px 'lato-bold', sans-serif;
    letter-spacing: normal;
    color: #231f20;
    margin: 0;
  }

  .modal-text {
    font: 12.5px/20px 'lato-regular', sans-serif;
    margin: 0 0 24px 0;
    color: #231f20;
  }
}
</style>
